import { Axios } from './Axios';

export async function getTeacherDataAndClasses(teacherId) {
  const url = `pub/class-details?userId=${teacherId}`;
  return Axios({
    url,
    method: 'get'
  });
}
